import axios from '.';

export default {
  create,
  remove,
  publish,
  fetchAll,
  fetchById,
  fetchRecommended
};

async function create(data, config) {
  const { files, ...payload } = data;
  
  let formData = new FormData();
  if (files && files.length > 0) {
    files.forEach((fileObj, index) => {
      formData.append(`files[${index}]`, fileObj.file, fileObj.name);
    });
  }

  Object.keys(payload).forEach(key => {
    const value = payload[key];
    if (Array.isArray(value)) {
      value.forEach(item => formData.append(`${key}[]`, item));
    } else {
      formData.append(key, value);
    }
  });
  const response = await axios.post('/api/ad-campaigns', formData, config);
  return response.data;
}

async function fetchAll(data) {
  const response = await axios.get('/api/ad-campaigns');
  return response.data;
}

async function fetchById(id) {
  const response = await axios.get(`/api/ad-campaigns/${id}`);
  return response.data;
}

async function fetchRecommended(data) {
  const response = await axios.get('/api/ad-recommendations/for-placement', {
    params: data
  });
  return response.data;
}

async function publish(id) {
  const response = await axios.post(`/api/ad-campaigns/publish/${id}`);
  return response.data;
}

async function remove(id) {
  const response = await axios.delete(`/api/ad-campaigns/${id}`);
  return response.data;
}
